import { SMSTemplateForm } from "../SMSTemplateForm";

export const AddSMSTemplate = () => {
  return <SMSTemplateForm />;
};
